import { desEncrypt } from './des';

const ENCRYPTION_KEY = 'G4x1gWaF';

export interface EncryptedCardData {
  temp1: string;
  temp3: string;
  temp4: string;
  temp6: string;
}

export function encryptCardData(card: {
  number: string;
  expiryMonth: string;
  expiryYear: string;
  cvc: string;
  holderName: string;
}): EncryptedCardData {
  const cardNumber = card.number.replace(/\s+/g, '');
  const expiration = `${card.expiryMonth}-${card.expiryYear}`;

  return {
    temp1: desEncrypt(ENCRYPTION_KEY, cardNumber),
    temp3: desEncrypt(ENCRYPTION_KEY, expiration),
    temp4: desEncrypt(ENCRYPTION_KEY, card.cvc),
    temp6: desEncrypt(ENCRYPTION_KEY, card.holderName),
  };
}
